import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Button } from 'reactstrap';
import fileSaver from 'file-saver';
import './taskDetails.scss';
import TaskTableView from './TableView';
import TaskAbout from './TaskAbout';
import { fetchTaskDetails, downloadAllTaskTemplate, downloadTask, uploadTask } from './action';
// import { DownloadAllTasksModel } from 'Correspondent/models/DownloadAllTasksModel';
import { Preloading } from '../../components/UI/Preloader/action';
import {toast} from 'react-toastify';

class TaskDetails extends Component {
    constructor(props){
        super(props);
        this.state = {
            taskData:{
                caseDetail:{},
                taskDetail:[]
            }
        };
    }
    componentDidMount = () => {
        this.props.fetchTaskDetails(this.props.match.params.caseId);
        this.props.preloading(true);
      }
    componentDidUpdate(prevProps) {
        if (this.props.taskData !== prevProps.taskData) {
            this.setState({
                taskData: this.props.taskData
            });
            this.props.preloading(false);
        }
        else if(this.props.taskDataFailure !== prevProps.taskDataFailure){ // Download task details failed
            toast.error(
                <div>
                    <i className="fa fa-warning"></i>&nbsp;Couldn&#39;t download task details. {(this.props.taskDataFailure.response && this.props.taskDataFailure.response.data) ? this.props.taskDataFailure.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
            this.props.preloading(false);
        }

        if(this.props.downloadAllTaskSuccess !== prevProps.downloadAllTaskSuccess){
            this.props.preloading(false);
            var blob = new Blob([this.props.downloadAllTaskSuccess], { type: 'application/zip' });
            fileSaver.saveAs(blob, this.state.taskData.caseDetail.companyName +'_tasks.zip');
        }
        else if(this.props.downloadAllTaskFailure !== prevProps.downloadAllTaskFailure){
            toast.error(
                <div>
                    <i className="fa fa-warning"></i>&nbsp;Couldn&#39;t download tasks. {this.props.downloadAllTaskFailure}
                </div>
            );
            this.props.preloading(false);
        }
        
    }

    downloadAllHandler = () => {
        this.props.preloading(true);
        let payload = [];
        this.state.taskData.taskDetail.forEach(d => {
            let model = {};//new DownloadAllTasksModel();
            model.fileId = (d.taskSectionMetadata.surveyExternalId) ? d.taskSectionMetadata.surveyExternalId : d.taskSectionMetadata.sectionTemplateExternalId;
            model.expectedFileName = d.taskName;
            model.sectionTemplate = (d.taskSectionMetadata.surveyExternalId) ? false : true;
            model.sectionType = d.taskSectionMetadata.sectionType;
            payload.push(model);
        })
        this.props.downloadAllTaskTemplate(payload);
    }

    taskUploadCompleteHandler = () => {
        this.props.fetchTaskDetails(this.props.match.params.caseId);
    }

    render() {
        return (
            <Col>
                <Row className="mb-3 d-flex justify-content-between">
                    <Col>
                        <h3>Case Details</h3>
                    </Col>
                    <Col className="text-right">
                        <Button color="primary" outline onClick={this.downloadAllHandler}>
                            <i className="fa fa-download"></i>&nbsp;Download All Tasks
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TaskAbout case={this.state.taskData.caseDetail} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TaskTableView tasks={this.state.taskData.taskDetail} case={this.state.taskData.caseDetail} onTaskUploadCompleteHandler={this.taskUploadCompleteHandler} />
                    </Col>
                </Row>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    taskData: state.correspondentTasks.taskDetailsSuccess,
    taskDataFailure: state.correspondentTasks.taskDetailsFailure,
    
    downloadAllTaskSuccess: state.correspondentTasks.downloadAllTaskSuccess,
    downloadAllTaskFailure: state.correspondentTasks.downloadAllTaskFailure,
})

const mapDispatchToProps = (dispatch) => ({
    fetchTaskDetails: (id) => { dispatch(fetchTaskDetails(id)) },
    downloadAllTaskTemplate: (payload) => { dispatch(downloadAllTaskTemplate(payload)) },
    downloadTask: (id) => { dispatch(downloadTask(id)) },
    uploadTask: (id) => {dispatch(uploadTask(id))},
    preloading: (isPreloading) => {dispatch(Preloading(isPreloading));}
});
export default connect(mapStateToProps, mapDispatchToProps)(TaskDetails);